
import { Vue, Component, Emit } from "vue-property-decorator";

@Component
export default class Form extends Vue {
  inputDescription = "";
  disabled = true;

  //emit
  @Emit("input-item")
  inputItem(): string {
    return this.inputDescription;
  }

  //computed
  get limitInputCheck(): string | null {
    if (this.inputDescription.length >= 20 || this.inputDescription.length <= 0) {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    return this.inputDescription.length >= 20 ? "20文字以内でお願いします😮" : "";
  }
}
